// Collapsible for header user dropdown
function openUserCollapsible(el) {
  el.classList.toggle('coll-active');
  var content = el.nextElementSibling;
  
  if(content.style.display === 'none') {
    content.style.display = 'block';
  } else {
    content.style.display = 'none';
  }
}

function onClickUserCollapsibleBackdrop(el) {
  el.parentElement.style.display = 'none';

  let userColls = document.querySelectorAll('.user-collapsible');

  for (let userColl of userColls) {
     userColl.classList.remove('coll-active'); 
  }
}